// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"287":"8907e379","818":"8907e379","2224":"35091658","2817":"8907e379","6280":"8907e379","6536":"41a168fd"}[chunkId] + ".chunk.css";
};